import { action } from 'typesafe-actions';
import { ActionType } from './job-interest.types';
import {
  ActivityTypes,
  ActivitySeverityType,
} from '../user-activity-trail/user-activity-trail.types';
import { mapJobInterestFormDataToAPIParams } from './job-interest.util';
import { ToastService } from '../../../services/ToastService';
import { MatchingService } from '../../../services/MatchingService';
import axios from 'axios';
import { ApiConstant } from '../../../constants';

export const getJobRequestFormData = (jobId) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_REQUEST_FORM_DATA_START));
    try {
      const jobRequestFormData = await MatchingService.get(`job-request-form-data/${jobId}`);
      dispatch(action(ActionType.GET_JOB_REQUEST_FORM_DATA, jobRequestFormData));
    } catch (e) {
      ToastService.error('Error occurred fetching job request form data', e);
    }
    dispatch(action(ActionType.JOB_REQUEST_FORM_DATA_COMPLETED));
  };
};

export const saveJobRequestFormData = (data) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_REQUEST_FORM_DATA_START));
    try {
      const { jobId } = data;
      const jobRequestFormData = await MatchingService.post(`job-request-form-data/${jobId}`, data);
      dispatch(action(ActionType.GET_JOB_REQUEST_FORM_DATA, jobRequestFormData));
      ToastService.success('Job request form data saved successfully');
    } catch (e) {
      ToastService.error('Error occurred saving job request form data', e);
    }
    dispatch(action(ActionType.JOB_REQUEST_FORM_DATA_COMPLETED));
  };
};

export const getJobInterestInfo = (hash) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_DETAILS_FETCH_STARTED));

    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Cache-Control', 'no-store');
      const jobInterest = await MatchingService.get(`job-request/${hash}`, headers);
      dispatch(action(ActionType.GET_JOB_INTEREST_DETAILS, jobInterest));
    } catch (e) {
      ToastService.error('Error Occurred Fetching Job Interest Details', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_DETAILS_FETCH_COMPLETED));
  };
};

export const getJobInfo = (hash) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));

    try {
      const jobInfo = await MatchingService.get(`job-request/${hash}/job-info`);
      dispatch(action(ActionType.GET_JOB_INFO, jobInfo));
    } catch (e) {
      console.log('error');
      console.log(e)
      ToastService.error('Error Occurred Fetching Job Info', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const getDeveloperInfoByJobInterestHash = (hash) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));

    try {
      const developerInfo = await MatchingService.get(`job-request/${hash}/developer-info`);
      dispatch(action(ActionType.GET_DEVELOPER_INFO, developerInfo));
    } catch (e) {
      ToastService.error('Error Occurred Fetching Developer Info', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const getNotInterestedReasons = () => {
  return async (dispatch) => {
    dispatch(action(ActionType.NOT_INTERESTED_REASONS_FETCH_STARTED));

    try {
      const notInterestedReasons = await MatchingService.get(
        `job-request/all-not-interested-reasons`,
      );
      dispatch(action(ActionType.GET_NOT_INTERESTED_REASONS, notInterestedReasons));
    } catch (e) {
      ToastService.error('Error Occurred Fetching Not Interested reasons', e);
    }

    dispatch(action(ActionType.NOT_INTERESTED_REASONS_FETCH_COMPLETED));
  };
};

export const saveJobInterestInfo = (jobInterest, redirectUrl, sendEmail = false) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));
    try {
      const { developerSupplyHostUrl, jobId } = await MatchingService.patch(
        `job-request`,
        mapJobInterestFormDataToAPIParams(jobInterest),
      );
      localStorage.removeItem(`icf_form_${jobInterest.idHash}`);
      if (sendEmail) {
        try {
          await axios.post(`${ApiConstant.BASE_URL}job/icf-submitted`, { jobInterest });
        } catch (e) {
          ToastService.error('Error Occurred sending Job Interest Email', e);
        }
      }
      dispatch(
        action(ActionType.UPDATE_JOB_INTEREST_DETAILS, { ...jobInterest, isSubmitAllowed: false }),
      );
      ToastService.success('Form submitted successfully');
      setTimeout(() => {
        if (
          jobInterest.vetsmithFlowLink == null ||
          jobInterest.vetsmithSatus ||
          !jobInterest.isInterested ||
          !jobInterest.jobMatchingVetsmithFlag
        ) {
          window.location.href = redirectUrl || developerSupplyHostUrl;
        } else {
          const vetsmithSubscribeLink = new URL(`/dashboard/jobs/${jobId}/specialized-vetting`, window.location.href);
          vetsmithSubscribeLink.searchParams.append('source', 'icf');
          window.location.href = vetsmithSubscribeLink;
        }
      }, 4000);
    } catch (e) {
      ToastService.error('Error Occurred saving Job Interest', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const getDeveloperAvailabilityFromHash = (hash) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));

    try {
      const data = await MatchingService.get(`job-request/${hash}/developer-availability`);
      const savedFormData = localStorage.getItem(`icf_form_${hash}`);
      const { developerAvailability } = JSON.parse(savedFormData || '{}');
      dispatch(
        action(ActionType.GET_DEVELOPER_AVAILABILITY_FROM_HASH, developerAvailability || data),
      );
    } catch (e) {
      ToastService.error('Error occurred fetching developer Availability', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const saveAvailabilityInformationFromJobInterestForm = (hash, availabilityInformation) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));
    try {
      const url = `job-request/${hash}/developer-availability`;
      await MatchingService.patch(url, availabilityInformation);
      dispatch(
        action(ActionType.UPDATE_DEVELOPER_AVAILABILITY_STATUS_FROM_JOB_INTEREST_FORM, {
          availabilityInformation,
          updateFromDB: true,
        }),
      );
    } catch (e) {
      ToastService.error('Error Occurred Saving Developer Availability', e);
    }
    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const getDeveloperRateDetailsFromJobRequestForm = (hash) => {
  return async (dispatch) => {
    dispatch(action(ActionType.JOB_INTEREST_REQUEST));

    try {
      const rateDetails = await MatchingService.get(`job-request/${hash}/developer-negotiated-rate`);
      dispatch(action(ActionType.GET_DEVELOPER_RATE_DETAILS_FROM_JOB_INTEREST_FORM, rateDetails));
    } catch (e) {
      if (e.statusCode === 403) {
        return;
      }
      ToastService.error('Error Occurred Fetching Developer Rate Details', e);
    }

    dispatch(action(ActionType.JOB_INTEREST_COMPLETED));
  };
};

export const saveRateChangeAttempt = (hash, data) => {
  return async (dispatch) => {
    try {
      const rateChangeAttemptCount = await MatchingService.post(
        `job-request/${hash}/developer-rate-attempt`,
        data,
      );
      const { attemptedNumber } = rateChangeAttemptCount;
      dispatch(
        action(ActionType.UPDATE_JOB_INTEREST_DETAILS, { devRateChangeAttempt: attemptedNumber }),
      );
    } catch (e) {
      console.log('e', e);
    }
  };
};

export const setDeveloperAvailability = (availabilityInformation) => {
  return async (dispatch) => {
    dispatch(
      action(ActionType.UPDATE_DEVELOPER_AVAILABILITY_STATUS_FROM_JOB_INTEREST_FORM, {
        availabilityInformation,
        updateFromDB: false,
      }),
    );
  };
};

export const setDeveloperExpectedRateDetails = (jobInterest) => {
  return async (dispatch) => {
    dispatch(action(ActionType.UPDATE_JOB_INTEREST_DETAILS, jobInterest));
  };
};

export const logICFSnapShot = (entityId, payload, severity = ActivitySeverityType.INFO) => {
  const { KEY, ACTIONS } = ActivityTypes.ICF;
  MatchingService.post('job-request/icf-snapshot', {
    category: KEY,
    action: ACTIONS.ICF_SESSION_SNAP_SHOT,
    entityId,
    payload,
    severity,
  });
};
